import { useEffect, useState } from 'react'

/** Viewport width at/above which screens use the wide side-by-side layout */
export const WIDE_BREAKPOINT = 900

/** Tracks whether the viewport is at least `breakpoint` px wide. */
export function useIsWide(breakpoint: number = WIDE_BREAKPOINT): boolean {
  const [isWide, setIsWide] = useState(() => window.innerWidth >= breakpoint)
  useEffect(() => {
    const handleResize = () => setIsWide(window.innerWidth >= breakpoint)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])
  return isWide
}
